var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M25.744,11.323a1.1,1.1,0,0,0-1,1.194,11.3,11.3,0,1,1-7.788-9.767,1.107,1.107,0,1,0,.68-2.106A13.5,13.5,0,1,0,13.479,27c.393,0,.789-.017,1.188-.051A13.517,13.517,0,0,0,26.95,12.326a1.1,1.1,0,0,0-1.205-1Z",
    fill: "#da4259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    d: "M2.189,1.086A1.095,1.095,0,0,0,0,1.086V9.13a1.095,1.095,0,0,0,2.189,0Z",
    transform: "translate(12.405 6.568)",
    fill: "#da4259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M1.095,0A1.1,1.1,0,0,0,.321.316,1.068,1.068,0,0,0,0,1.078v.034A1.086,1.086,0,0,0,1.095,2.189,1.086,1.086,0,0,0,2.189,1.111V1.078A1.068,1.068,0,0,0,1.869.316,1.1,1.1,0,0,0,1.095,0Z",
    transform: "translate(12.405 18.973)",
    fill: "#da4259"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIc);
export default __webpack_public_path__ + "static/media/warning-ic.85fb62c03430cff6c8d5ef21bd77fd69.svg";
export { ForwardRef as ReactComponent };